import { API_ROOT } from '../../config/config'
import { doDelete, doDownload, doGet, doPost, doPut } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const getExpenses = (projectCode, period, id) => {
  const url = `${API_ROOT}/v1/accounting/expenses/${projectCode}/${period}?id=${id || ''}`
  return doGet(url)
}

export const saveExpenses = (request, projectCode, period) => {
  const url = `${API_ROOT}/v1/accounting/expenses/${projectCode}/${period}`
  return doPost(url, request)
}

export const getExpensesAttachments = (fileId) => {
  const url = `${API_ROOT}/v1/accounting/download/expenses/attachments/${fileId}`
  return doDownload(url)
}

export const getTaxWaiteSend = (projectCode, period, type, month) => {
  const url = `${API_ROOT}/v1/accounting/expenses/tax/waite-send/${projectCode}/${period}?type=${
    type || ''
  }&month=${month || ''}`
  return doGet(url)
}

export const deleteExpenses = (id) => {
  const url = `${API_ROOT}/v1/accounting/expenses/${id}`
  return doDelete(url)
}

export const downloadPaymentVoucherFile = (accountingExpensesId) => {
  const url = `${API_ROOT}/files/${accountingExpensesId}/payment/voucher/form`
  return doDownload(url)
}

export const downloadDurableArticlesFile = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

export const downloadExpensesDurableArticlesFile = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

export const downloadEFilingFile = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

export const downloadWithholdingDocumentFile = (pathFile) => {
  const url = `${API_ROOT}/v1/accounting/download/file?filePath=${pathFile}`
  return doDownload(url)
}

export const getExpensesCheckList = (request, projectCode, period) => {
  const url = `${API_ROOT}/v1/accounting/expenses/check/${projectCode}/${period}/page`
  return doPost(url, request)
}

export const getExpensesCheckById = (projectCode, period, id) => {
  const url = `${API_ROOT}/v1/accounting/expenses/check/${projectCode}/${period}/${id}`
  return doGet(url)
}

export const UpdateExpensesCheck = (request, projectCode, period) => {
  const url = `${API_ROOT}/v1/accounting/expenses/check/${projectCode}/${period}/update`
  return doPut(url, request)
}

export const downloadAssetRegisterFile = (projectCode) => {
  const url = `${API_ROOT}/files/${projectCode}/asset/register/form`
  return doDownload(url)
}

export const downloadCheckFile = (projectCode, period) => {
  const url = `${API_ROOT}/files/${projectCode}/accounting/check/file/${period}`
  return doDownload(url)
}
